var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoaderCard from '../loader-card/LoaderCard';
import { RolesEnum } from '@/items/Roles';
let MoveToAreaDialog = class MoveToAreaDialog extends Vue {
    constructor() {
        super(...arguments);
        // TODO: Method was not defined. When can a skillset be added?
        this.formValid = false;
        this.selectedArea = null;
    }
    closeDialog() {
        this.$emit('input', false);
    }
    async add() {
        this.$emit('confirm', this.selectedArea);
        this.closeDialog();
        // HERE add subjects or topics to Area
    }
    /**
     * if isLoading = false && skillSets.length === 0;
     *
     * dont show the dropdown
     * but instead so a text and a link
     * 'All skill sets have been linked to this student'
     * You can add new SKillsets here <link to skillsets>
     */
    get canAddSkillSets() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.ROOT, RolesEnum.TEACHER]);
    }
    get canAddSkillSet() {
        return !!true;
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], MoveToAreaDialog.prototype, "areas", void 0);
MoveToAreaDialog = __decorate([
    Component({
        components: {
            LoaderCard,
        },
    })
], MoveToAreaDialog);
export default MoveToAreaDialog;
